import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Image from "images/png/landingPageProcess.png";
import { ReactComponent as Waves } from "images/svg/processWaves.svg";
import { ReactComponent as Stars } from "images/svg/processStars.svg";
import BGImg from "images/png/processBgImg.png";

const Process = () => {
  return (
    <Container>
      <Typography
        align="center"
        size="4.8rem"
        m_size="2.8rem"
        weight="bold"
        mb="1.6"
        m_mb="1.2"
        dataAos="fade-up"
      >
        Get Your Music Out There
      </Typography>
      <Typography
        align="center"
        size="xl"
        color={Colors.grey400}
        mb="3.2"
        m_size="m"
        dataAos="fade-up"
      >
        Follow These Simple Steps To Start Releasing Your Music
      </Typography>
      <Body>
        <BodyBgImg src={BGImg} alt="bg-img" />
        <StarsContainer>
          <Stars />
        </StarsContainer>
        <Steps data-aos="fade-right">
          <Step>
            <Typography
              size="9.6rem"
              m_size="4.8rem"
              weight="semibold"
              color={Colors.grey400}
            >
              01
            </Typography>
            <StepText>
              <Typography
                size="4xl"
                m_size="lg"
                color={Colors.grey400}
                weight="semibold"
                mb="1.6"
              >
                Sign Up & Create Your Profile
              </Typography>
              <Typography size="2xl" m_size="m" color={Colors.grey500}>
                Join Rated Afrika and set up your artist profile in minutes.{" "}
              </Typography>
            </StepText>
          </Step>
          <Step>
            <Typography
              size="9.6rem"
              m_size="4.8rem"
              weight="semibold"
              color={Colors.grey400}
            >
              02
            </Typography>
            <StepText>
              <Typography
                size="4xl"
                m_size="lg"
                color={Colors.grey400}
                weight="semibold"
                mb="1.6"
              >
                Upload Your Music & Videos
              </Typography>
              <Typography size="2xl" m_size="m" color={Colors.grey500}>
                Easily upload your content and add all the details..
              </Typography>
            </StepText>
          </Step>
          <Step>
            <Typography
              size="9.6rem"
              m_size="4.8rem"
              weight="semibold"
              color={Colors.grey400}
            >
              03
            </Typography>
            <StepText>
              <Typography
                size="4xl"
                m_size="lg"
                color={Colors.grey400}
                weight="semibold"
                mb="1.6"
              >
                Get Distributed & Track Performance
              </Typography>
              <Typography size="2xl" m_size="m" color={Colors.grey500}>
                Hit “publish,” and we’ll distribute your content to top
                platforms worldwide. Monitor streams, downloads, and fan
                engagement.
              </Typography>
            </StepText>
          </Step>
          <Step>
            <Typography
              size="9.6rem"
              m_size="4.8rem"
              weight="semibold"
              color={Colors.grey400}
            >
              04
            </Typography>
            <StepText>
              <Typography
                size="4xl"
                m_size="lg"
                color={Colors.grey400}
                weight="semibold"
                mb="1.6"
              >
                Get Paid with Ease
              </Typography>
              <Typography size="2xl" m_size="m" color={Colors.grey500}>
                Earnings are tracked in real-time, with automated payments sent
                directly to you and your team.
              </Typography>
            </StepText>
          </Step>
        </Steps>
        <PhoneImage
          src={Image}
          alt="Landing Page Process"
          data-aos="fade-left"
        />
      </Body>
      <WaveContainer>
        <Waves />
      </WaveContainer>
    </Container>
  );
};

export default Process;

const Container = styled.div`
  min-height: 91.2rem;
  padding-top: 4rem;
  color: white;
  overflow: hidden;
  @media only screen and (max-width: 769px) {
    min-height: 100rem;
    width: 100%;
    padding: 0rem;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Body = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
  }
`;

const BodyBgImg = styled.img`
  position: absolute;
  width: 100%;
  height: 53rem;
  @media only screen and (max-width: 769px) {
    height: 30rem;
    bottom: 0;
  }
`;
const Steps = styled.div`
  margin-left: 11.6rem;
  width: 40%;
  @media only screen and (max-width: 769px) {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`;
const Step = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2.4rem;
`;

const StepText = styled.div`
  margin-left: 1rem;
`;

const PhoneImage = styled.img`
  width: 45%;
  position: relative;
  z-index: 1;
  @media only screen and (max-width: 769px) {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const WaveContainer = styled.div`
  width: 100%;
  margin-top: -10rem;
  @media only screen and (max-width: 769px) {
    margin-top: 0;
  }
`;

const StarsContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 0;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;
